import {gql} from "@apollo/client/core";
import {LocaleFragment} from "../../../checkout/graphql/fragments/locale-fragment";

export const GetRetailLocales = gql`
    query getRetailLocales
    {
        getRetailLocales {
            ...LocaleFragment
        }
    }
    ${LocaleFragment}
`;

export const GetEnrollPcLocales = gql`
    query getEnrollPcLocales
    {
        getEnrollPcLocales {
            ...LocaleFragment
        }
    }
    ${LocaleFragment}
`;

export const GetEnrollAffiliateLocales = gql`
    query getEnrollAffiliateLocales
    {
        getEnrollAffiliateLocales {
            ...LocaleFragment
        }
    }
    ${LocaleFragment}
`;
